<template>
  <v-radio-group
    @change="$emit('onChange', $event)"
    :value="selected"
    hide-details
    row>
    <v-radio
      v-for="(option, index) in options"
      :key="index"
      :label="option.name"
      :value="option.id"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      required: true,
    },
  },

  computed: {
    options() {
      return [
        { id: 1, name: '単元検索' },
        { id: 2, name: '教科書ページ検索' },
      ]
    },
  },
}
</script>
